import {
  GET_BOOKING_MODIFICATION_FACILITIES,
  GET_BOOKING_MODIFICATION_FACILITIES_SUCCESS,
  GET_BOOKING_MODIFICATION_FACILITIES_ERROR,
  GET_BOOKING_MODIFICATION_FACILITIES_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBookingModificationFacilities = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING_MODIFICATION_FACILITIES:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BOOKING_MODIFICATION_FACILITIES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_BOOKING_MODIFICATION_FACILITIES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BOOKING_MODIFICATION_FACILITIES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBookingModificationFacilities;
